import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Alif Lamato Forged Wheels',
    description: 'Bespoke forged monoblock wheels by master artisan Alif Lamato. 6061-T6 aerospace aluminum, custom offsets from ET -15 to +45 and hand-finished detail, engineered for a fitment beyond standard.',
    tagline: 'Engineered Perfection. Beyond Standard Fitment.',
    ogImage: 'https://alif-lamato-bespoke-forged-wheels.cdn.modulify.website/images/social-preview.jpg',
    url: getOrigin()
}
